module.exports = __webpack_public_path__ + "img/ceramic-angry.aff73f79.jpg";